<script>
	
	import { onMount } from 'svelte';
	import { getCompanyData } from "../../../../api/Company";
	import NewProductForm from "./newProduct/index.svelte";
	import CompanyProducts from "./companyProducts/index.svelte";
	import OpenProduct from "./openProduct/index.svelte";
	import EditProduct from "./editProduct/index.svelte";
	import {setState, getState} from "../../../../stores.js";
    import { handleSystemErrors } from '../../../../api/utils';

	// default state false
	let newProduct = getState('newProduct') || false;

	let openProduct = getState('openProduct') || false;
	let editProduct = getState('editProduct') || false;

	let selectedProduct = getState('selectedProduct') || null;

	let dataSaved = false;
	let submitData = false;

	let company = null;

	var companyName = null; 
	var user = null;

	var companyInfo = {

		CompanyName: null,
		Country: null,
		Address1: null,
		Address2: null,
		Products:null
	}

	let companyProducts = null;

	onMount(async() =>{

		user = localStorage.getItem('user');
		user =  JSON.parse(user);
		companyName = user.company;

		if(companyName != 'none'){

			var res = await getCompanyData({companyName: companyName});

			if(res.status == 'valid'){

				company = res.company;
				companyProducts = company.Products;
				localStorage.setItem('company', JSON.stringify(company));

			}
			else if(res.status == 'error'){
				await handleSystemErrors(res.err);
			}

		}

	});


const handlegoBackBtn = () =>{

	if(newProduct){
		newProduct = false;
		setState('newProduct', false);
	}
	else{

		if(openProduct){
			openProduct = false;
			setState('openProduct', false);
		}
		else if(editProduct){
			editProduct = false;
			setState('editProduct', false);
		}
		else{

		}
	}
}
	

</script>


<div class="companyInfoContainer">

	<div class="companyAddContainer">


		<div class="topContainer ">

			<div class="goBackBtnContainer">
				

				{#if newProduct ||openProduct || editProduct}
					<div class="goBackBtn" on:click={() => handlegoBackBtn()}>
						Cancel
					</div>
				{/if}


				{#if newProduct || editProduct}
					
					{#if dataSaved}
						<div class="dataHandleBtn inactiveBtn">
							Save
						</div>

						<div class="dataHandleBtn activeBtn" on:click={() => {submitData = true;}}>
							Submit
						</div>
					{:else}
						<div class="dataHandleBtn activeBtn" on:click={() => {dataSaved = true;}}>
							Save
						</div>

						<div class="dataHandleBtn inactiveBtn">
							Submit
						</div>
					{/if}
					
				{:else}

					{#if company != null}
						<div class="dataHandleBtn activeBtn" on:click={() => {newProduct = true; setState('newProduct', true);}}>
							Add new 
						</div>
					{:else}
						<div class="dataHandleBtn inactiveBtn">
							Add new 
						</div>
					{/if}
				{/if}
				
				
					
			</div>

		</div>

		<div class="formContainer">


			{#if newProduct} <!-- newProductTable -->
				<NewProductForm  companyName={companyName} bind:dataSaved={dataSaved} 
				bind:submitData={submitData} bind:newProduct={newProduct}/>
			{:else} <!-- company products Table -->

				{#if openProduct == false && editProduct == false}

					<CompanyProducts bind:selectedProduct={selectedProduct}  bind:openProduct={openProduct} bind:editProduct={editProduct}   companyProducts={companyProducts}/>
				{:else if openProduct}
					<OpenProduct selectedProduct={selectedProduct}/>
				{:else if editProduct}
					<EditProduct openProduct={openProduct} editProduct={editProduct} companyName={companyName} selectedProduct={selectedProduct}  bind:dataSaved={dataSaved} bind:submitData={submitData}/>
				{:else}
					ola
				{/if}
			{/if}
			
		</div>				
			
	</div>

</div>


<style>

	.meanTableContainer{
		width: 100%;
		height: 100%;
		/*background-color: green;*/
		display: flex;
		flex-direction: column;
	}

	.meanTableRow{
		width: 100%;
		height: 8.8%;
		display: flex;
		flex-direction: row;
		background-color: #1F1F1F;
		border-bottom-color: white;
		border-bottom-width:  0.06510416666666667vw;
		border-bottom-style: solid;
	}


	.meanTableRowItem{
		width: 25%;
		height: 100%;
		color: white;
		display: flex;
		align-items: center;
		/*background-color: blue;*/
		font-size: 0.8463541666666666vw;
		font-weight: 700;
		/*opacity: 0.8;*/
	}
	.meanTableRowItem:nth-child(5){
		justify-content: center;	
	}

	.meanTableRow:nth-child(even){
		/*background-color:grey;*/
	}
	
	.companyInfoContainer{
		width: 100%;
		height: 100%;
		/*background-color: orangered;*/
		display: flex;
		flex-direction: column;
		align-items: center;
		/*justify-content: center;*/
	}


	.companyAddContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-start;
		/*background-color: orange;*/
	}

	.topContainer{
		width: 100%;
		height: 6%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-end;
		border-radius: 5px;
		margin-top: 3%;
		/*background-color: red;*/
	}
	.goBackBtnContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		margin-top: 0.4%;
	}

	.goBackBtn{
		width: 10%;
		height: 100%;
		border: 1px rgba(255, 255, 255, 0.5) solid;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #f44336;
		border-radius: 3px;
		font-size: 0.9114583333333334vw;
		cursor: pointer;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}

	.goBackBtn:hover{
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
		transform: translateY(0px);
	}


	.dataHandleBtn:nth-child(2), .dataHandleBtn:nth-child(3){
		margin-left: 2%;
	}

	.dataHandleBtn{
		width: 10%;
		height: 100%;
		border: 1px rgba(255, 255, 255, 0.5) solid;
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--brand-accent);
		opacity: 0.8;
		border-radius: 3px;
		font-size: 0.9114583333333334vw;
		cursor: pointer;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}



	.cancelBtn{
		color:  red;
	}

	.activeBtn{
	}

	.activeBtn:hover{
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
        transform: translateY(0px); 
	}


	.inactiveBtn{
		opacity: 0.5;
		color: black;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	}

	.formContainer{
		width: 98%;
		height: 70%;
		/*background-color: orange;*/
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		margin-top: 2%;
	}


</style>